<template>
  <div class="tl-empty-item column items-center text-grey">
    <q-icon name="fas fa-box-open" :size="iconSize" />
    <span
      :style="{
        fontSize: textSize,
      }"
      class="q-mt-sm"
    >
      {{ text }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    iconSize: {
      type: String,
      default: "3rem",
    },
    text: {
      type: String,
      default: "没有找到任何项目",
    },
    textSize: {
      type: String,
      default: "0.8rem",
    },
  },
};
</script>
